/**订货商城路由 */
import { ROUTE } from '@/helpers/constants/route.js'
const mallSettings = () => import('@/views/web/mall/mallSettings/index.vue') /**商城配置 */
const mallCategoryManage = () => import('@/views/web/mall/categoryManage/index.vue') /**商城分类管理 */
const mallGoodsManage = () => import('@/views/web/mall/goodsManage/index.vue') /**商品管理 */
const mallDress = () => import('@/views/web/mall/mallSettings/mallDress.vue') /**商品装扮 */
const settingSet = () => import('@/views/web/mall/mallSettings/settingSet.vue') /**商城配置设置 */
const saveGood = () => import('@/views/web/mall/goodsManage/saveGood.vue') /**商品管理编辑 */
export default [
  {
    path: ROUTE.MALL_SETTINGS, /**商城配置 */
    component: mallSettings,
    name: '商城配置',
    meta: {
      title: '商城配置'
    }
    // children: [
    //   {
    //     path: '/set', /**商城配置设置 */
    //     meta: {title: '配置商城'},
    //     component: settingSet
    //   }
    // ]
  },
  {
    path: ROUTE.MALL_CATEGORY_MANAGE,  /**商城分类管理 */
    name: '商品分类管理',
    component: mallCategoryManage,
    meta: { title: '商品分类管理' }
  },
  {
    path: ROUTE.MALL_GOODS_MANAGE, /**商品管理 */
    component: mallGoodsManage,
    name: '商品管理',
    meta: { title: '商品管理' }
  },
  {
    path: ROUTE.MALL_DRESS,/**商品装扮 */
    component: mallDress,
    name: '商城装修',
    meta: { title: '商城装修' }
  },
  {
    path: ROUTE.SETTING_SET, /**商城配置设置 */
    name: '配置商城',
    meta: { title: '配置商城' },
    component: settingSet
  },
  {
    path: ROUTE.SAVE_GOOD, /**商品管理编辑 */
    name: '创建商品',
    meta: { title: '创建商品' },
    component: saveGood
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/mall.js